import { FormControlLabel, styled } from "@mui/material";
import { MOCK_TOKENS } from "./tokens";
const StyledLabel = styled(FormControlLabel)(({ theme, size }) => {
  return {
    gap: "8px",
    ".MuiTypography-root": {
      fontSize: theme.typography[MOCK_TOKENS.size[size]].fontSize,
      fontWeight: theme.typography[MOCK_TOKENS.size[size]].fontWeight,
      lineHeight: theme.typography[MOCK_TOKENS.size[size]].lineHeight
    }
  };
});
export {
  StyledLabel
};
